var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Article as FileIcon, Draw as DrawIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, Warning as WarningIcon } from '@mui/icons-material';
import { Alert, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { getDetalhamentoFolha } from '../fechamento_mensal_service';
var STATUS_DIA_STYLES = {
    APROVADO: { color: '#166534', bg: '#dcfce7' },
    JUST_APROVADA: { color: '#92400e', bg: '#fef3c7' },
    JUST_REPROVADA: { color: '#991b1b', bg: '#fee2e2' },
    REPROVADO: { color: '#991b1b', bg: '#fee2e2' },
    PENDENTE: { color: '#4b5563', bg: '#f3f4f6' },
};
var getBadgeStyle = function (codigo) {
    var _a;
    var key = codigo.replace(/[.\s]+/g, '_').toUpperCase();
    return (_a = STATUS_DIA_STYLES[key]) !== null && _a !== void 0 ? _a : STATUS_DIA_STYLES['PENDENTE'];
};
export function ModalDetalhamentoFolha(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var open = _a.open, onClose = _a.onClose, folhaId = _a.folhaId, dataInicio = _a.dataInicio, dataFim = _a.dataFim, onVisualizarJustificativa = _a.onVisualizarJustificativa;
    var _p = useState(false), loading = _p[0], setLoading = _p[1];
    var _q = useState(null), dados = _q[0], setDados = _q[1];
    var carregarDetalhamento = useCallback(function (id, isAtivo) { return __awaiter(_this, void 0, void 0, function () {
        var resp, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getDetalhamentoFolha(id, {
                            data_inicio: dataInicio,
                            data_fim: dataFim,
                        })];
                case 2:
                    resp = _a.sent();
                    if (isAtivo() && resp)
                        setDados(resp === null || resp === void 0 ? void 0 : resp.dados);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao carregar detalhamento da folha:', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    if (isAtivo())
                        setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [dataFim, dataInicio]);
    useEffect(function () {
        var ativo = true;
        if (open && folhaId) {
            carregarDetalhamento(folhaId, function () { return ativo; });
        }
        if (!open) {
            setDados(null);
        }
        return function () {
            ativo = false;
        };
    }, [open, folhaId, dataInicio, dataFim, carregarDetalhamento]);
    var colunasVisiveis = (_d = (_c = (_b = dados === null || dados === void 0 ? void 0 : dados.tabela_dias) === null || _b === void 0 ? void 0 : _b.colunas) === null || _c === void 0 ? void 0 : _c.filter(function (c) { return c.visivel; })) !== null && _d !== void 0 ? _d : [];
    var exibirE2S2 = colunasVisiveis.some(function (c) { return c.codigo === 'E2'; }) && colunasVisiveis.some(function (c) { return c.codigo === 'S2'; });
    var handleExportarPdf = function () {
        var _a, _b;
        if (!((_a = dados === null || dados === void 0 ? void 0 : dados.folha) === null || _a === void 0 ? void 0 : _a.id))
            return;
        var params = new URLSearchParams({ folhaId: String(dados.folha.id) });
        var periodo = (_b = dados.folha.periodo_fechamento_registrado) !== null && _b !== void 0 ? _b : dados.folha.periodo_fechamento;
        if ((periodo === null || periodo === void 0 ? void 0 : periodo.data_inicio) && (periodo === null || periodo === void 0 ? void 0 : periodo.data_fim)) {
            params.append('data_inicio', periodo.data_inicio);
            params.append('data_fim', periodo.data_fim);
        }
        var url = "/painel/gestao-frequencia/relatorio-frequencia?".concat(params.toString());
        window.open(url, '_blank');
    };
    var isValorNeutroFimDeSemana = function (valor) { return valor === '—' || valor === '---' || !valor; };
    var getDiaSemanaExibicao = function (dataIso) {
        var _a;
        var _b = dataIso.split('-').map(Number), ano = _b[0], mes = _b[1], dia = _b[2];
        if (!ano || !mes || !dia)
            return '';
        var data = new Date(Date.UTC(ano, mes - 1, dia));
        var diasSemana = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];
        return (_a = diasSemana[data.getUTCDay()]) !== null && _a !== void 0 ? _a : '';
    };
    var isLinhaFimDeSemanaNeutra = function (linha) {
        return linha.dia_tipo === 'FIM_DE_SEMANA' &&
            !linha.status_dia.exibir_badge &&
            Object.values(linha.registros_ponto).every(isValorNeutroFimDeSemana) &&
            !linha.justificativa.pode_visualizar &&
            isValorNeutroFimDeSemana(linha.justificativa.texto);
    };
    var renderBatidaCell = function (valor, isFdsNeutro) {
        if (isFdsNeutro && isValorNeutroFimDeSemana(valor)) {
            return (_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af', fontSize: '0.78rem' } }, { children: "---" })));
        }
        var semBatida = valor === '--:--';
        return (_jsx(Typography, __assign({ variant: 'body2', sx: {
                fontWeight: 600,
                fontSize: '0.78rem',
                color: semBatida ? '#ef4444' : '#111827',
            } }, { children: valor })));
    };
    var renderStatusDia = function (status, isFdsNeutro) {
        var _a;
        if (isFdsNeutro && !status.exibir_badge) {
            return (_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af', fontSize: '0.78rem' } }, { children: "---" })));
        }
        if (!status.exibir_badge) {
            return (_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af', fontSize: '0.78rem' } }, { children: status.label || '---' })));
        }
        var style = getBadgeStyle((_a = status.codigo) !== null && _a !== void 0 ? _a : '');
        return (_jsx(Chip, { label: status.label, size: 'small', sx: {
                backgroundColor: style.bg,
                color: style.color,
                fontWeight: 700,
                fontSize: '0.65rem',
                height: 20,
            } }));
    };
    var renderJustificativa = function (just, isFdsNeutro) {
        var _a;
        if (isFdsNeutro && !just.pode_visualizar && isValorNeutroFimDeSemana(just.texto)) {
            return (_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af', fontSize: '0.78rem' } }, { children: "---" })));
        }
        if (just.pode_visualizar && just.justificativa_id) {
            return (_jsx(Button, __assign({ size: 'small', startIcon: _jsx(VisibilityIcon, { sx: { fontSize: 14 } }), onClick: function () {
                    var _a;
                    if (onVisualizarJustificativa && ((_a = dados === null || dados === void 0 ? void 0 : dados.folha) === null || _a === void 0 ? void 0 : _a.id) && just.justificativa_id) {
                        onVisualizarJustificativa(dados.folha.id, just.justificativa_id);
                    }
                }, sx: {
                    fontWeight: 700,
                    textTransform: 'none',
                    color: '#2563eb',
                    fontSize: '0.72rem',
                    minWidth: 'auto',
                    p: '2px 8px',
                    '&:hover': { backgroundColor: '#eff6ff' },
                } }, { children: "VISUALIZAR" })));
        }
        return (_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af', fontSize: '0.78rem' } }, { children: (_a = just.texto) !== null && _a !== void 0 ? _a : 'Sem Ocorrências' })));
    };
    var statusCodigo = (_f = (_e = dados === null || dados === void 0 ? void 0 : dados.folha) === null || _e === void 0 ? void 0 : _e.status) === null || _f === void 0 ? void 0 : _f.codigo;
    var tituloModal = ((_g = dados === null || dados === void 0 ? void 0 : dados.cabecalho) === null || _g === void 0 ? void 0 : _g.reeducando_nome_exibicao)
        ? "Detalhamento da Folha - ".concat(dados.cabecalho.reeducando_nome_exibicao)
        : 'Detalhamento da Folha';
    var getRodapeBg = function () {
        if (statusCodigo === 'EM_PREENCHIMENTO')
            return '#fffbeb';
        if (statusCodigo === 'DEVOLVIDA_PARA_CORRECAO')
            return '#fff7ed';
        return '#f9fafb';
    };
    var getRodapeMsgColor = function () {
        if (statusCodigo === 'EM_PREENCHIMENTO')
            return '#92400e';
        if (statusCodigo === 'DEVOLVIDA_PARA_CORRECAO')
            return '#c2410c';
        return '#6b7280';
    };
    return (_jsxs(Dialog, __assign({ open: open, onClose: undefined, fullWidth: true, maxWidth: 'lg', PaperProps: { sx: { borderRadius: 3, overflow: 'hidden' } } }, { children: [_jsx(DialogTitle, __assign({ sx: { display: 'none' } }, { children: tituloModal })), _jsx(DialogContent, __assign({ sx: { p: 0, minHeight: 500 } }, { children: loading ? (_jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 500 } }, { children: _jsx(CircularProgress, { size: 40, thickness: 4 }) }))) : dados ? (_jsxs(Box, { children: [((_h = dados.alerta_periodo_consulta) === null || _h === void 0 ? void 0 : _h.exibir) && (_jsx(Alert, __assign({ severity: 'warning', icon: _jsx(WarningIcon, { fontSize: 'small' }), sx: {
                                borderRadius: 0,
                                backgroundColor: '#fff7ed',
                                color: '#9a3412',
                                border: 'none',
                                borderBottom: '1px solid #fed7aa',
                                '& .MuiAlert-icon': { color: '#ea580c' },
                            } }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: { fontWeight: 700 } }, { children: dados.alerta_periodo_consulta.mensagem })) }))), ((_j = dados.alerta_devolucao) === null || _j === void 0 ? void 0 : _j.exibir) && (_jsxs(Alert, __assign({ severity: 'warning', icon: _jsx(WarningIcon, { fontSize: 'small' }), sx: {
                                borderRadius: 0,
                                backgroundColor: '#fffbeb',
                                color: '#92400e',
                                border: 'none',
                                borderBottom: '1px solid #fde68a',
                                '& .MuiAlert-icon': { color: '#d97706' },
                            } }, { children: [_jsxs(Typography, __assign({ variant: 'body2', sx: { fontWeight: 800, mb: 0.5 } }, { children: ["\u26A0 ", dados.alerta_devolucao.label] })), _jsx(Typography, __assign({ variant: 'caption', sx: { color: '#78350f' } }, { children: dados.alerta_devolucao.motivo }))] }))), _jsxs(Box, __assign({ sx: {
                                p: 2.5,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                flexWrap: 'wrap',
                                gap: 2,
                                borderBottom: '1px solid #e5e7eb',
                                backgroundColor: '#f9fafb',
                            } }, { children: [_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: 'h6', sx: { fontWeight: 800, color: '#111827', textTransform: 'uppercase', lineHeight: 1.2 } }, { children: tituloModal })), _jsxs(Typography, __assign({ variant: 'body2', sx: { color: '#6b7280', mt: 0.5, fontSize: '0.82rem' } }, { children: [dados.cabecalho.matricula_exibicao, " \u00B7 ", dados.cabecalho.empresa_prestadora] })), ((_k = dados.folha.periodo_fechamento) === null || _k === void 0 ? void 0 : _k.descricao) && (_jsxs(Typography, __assign({ variant: 'caption', sx: { color: '#6b7280', mt: 0.5, display: 'block', fontSize: '0.75rem' } }, { children: ["Per\u00EDodo de Apura\u00E7\u00E3o: ", dados.folha.periodo_fechamento.descricao] })))] }), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 1.5, flexShrink: 0 } }, { children: [_jsxs(Box, __assign({ sx: {
                                                textAlign: 'center',
                                                px: 2,
                                                py: 1,
                                                borderRadius: 2,
                                                border: '1px solid #dcfce7',
                                                backgroundColor: '#f0fdf4',
                                                minWidth: 80,
                                            } }, { children: [_jsx(Typography, __assign({ variant: 'h5', sx: { fontWeight: 800, color: '#16a34a', lineHeight: 1 } }, { children: dados.kpis.aprovados })), _jsx(Typography, __assign({ variant: 'caption', sx: { color: '#166534', fontWeight: 600, fontSize: '0.65rem' } }, { children: "APROVADOS" }))] })), _jsxs(Box, __assign({ sx: {
                                                textAlign: 'center',
                                                px: 2,
                                                py: 1,
                                                borderRadius: 2,
                                                border: '1px solid #fee2e2',
                                                backgroundColor: '#fef2f2',
                                                minWidth: 80,
                                            } }, { children: [_jsx(Typography, __assign({ variant: 'h5', sx: { fontWeight: 800, color: '#dc2626', lineHeight: 1 } }, { children: dados.kpis.reprovados })), _jsx(Typography, __assign({ variant: 'caption', sx: { color: '#991b1b', fontWeight: 600, fontSize: '0.65rem' } }, { children: "REPROVADOS" }))] })), _jsxs(Box, __assign({ sx: {
                                                textAlign: 'center',
                                                px: 2,
                                                py: 1,
                                                borderRadius: 2,
                                                border: '1px solid #e5e7eb',
                                                backgroundColor: '#f9fafb',
                                                minWidth: 80,
                                            } }, { children: [_jsx(Typography, __assign({ variant: 'h5', sx: { fontWeight: 800, color: '#111827', lineHeight: 1 } }, { children: dados.kpis.pendencias })), _jsx(Typography, __assign({ variant: 'caption', sx: { color: '#4b5563', fontWeight: 600, fontSize: '0.65rem' } }, { children: "PEND\u00CANCIAS" }))] }))] }))] })), _jsx(TableContainer, __assign({ sx: { maxHeight: 420, overflowY: 'auto' } }, { children: _jsxs(Table, __assign({ size: 'small', stickyHeader: true, "aria-label": 'tabela de frequ\u00EAncia do per\u00EDodo' }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "DATA" })), _jsx(TableCell, __assign({ align: 'center', sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "E1" })), _jsx(TableCell, __assign({ align: 'center', sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "S1" })), exibirE2S2 && (_jsxs(_Fragment, { children: [_jsx(TableCell, __assign({ align: 'center', sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "E2" })), _jsx(TableCell, __assign({ align: 'center', sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "S2" }))] })), _jsx(TableCell, __assign({ sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "STATUS DO DIA" })), _jsx(TableCell, __assign({ sx: { fontWeight: 700, fontSize: '0.72rem', color: '#374151', backgroundColor: '#f1f5f9' } }, { children: "JUSTIFICATIVA" }))] }) }), _jsx(TableBody, { children: dados.tabela_dias.linhas.map(function (linha) {
                                            var isFdsNeutro = isLinhaFimDeSemanaNeutra(linha);
                                            return (_jsxs(TableRow, __assign({ sx: {
                                                    backgroundColor: isFdsNeutro ? '#fafafa' : 'white',
                                                    '&:last-child td': { borderBottom: 0 },
                                                } }, { children: [_jsx(TableCell, { children: _jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', lineHeight: 1.2 } }, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: {
                                                                        fontSize: '0.78rem',
                                                                        color: isFdsNeutro ? '#9ca3af' : '#111827',
                                                                        fontWeight: isFdsNeutro ? 400 : 600,
                                                                    } }, { children: linha.data_exibicao })), _jsx(Typography, __assign({ variant: 'caption', sx: {
                                                                        mt: 0.35,
                                                                        fontSize: '0.66rem',
                                                                        color: isFdsNeutro ? '#9ca3af' : '#6b7280',
                                                                        textTransform: 'uppercase',
                                                                    } }, { children: getDiaSemanaExibicao(linha.data) }))] })) }), _jsx(TableCell, __assign({ align: 'center' }, { children: renderBatidaCell(linha.registros_ponto.E1, isFdsNeutro) })), _jsx(TableCell, __assign({ align: 'center' }, { children: renderBatidaCell(linha.registros_ponto.S1, isFdsNeutro) })), exibirE2S2 && (_jsxs(_Fragment, { children: [_jsx(TableCell, __assign({ align: 'center' }, { children: renderBatidaCell(linha.registros_ponto.E2, isFdsNeutro) })), _jsx(TableCell, __assign({ align: 'center' }, { children: renderBatidaCell(linha.registros_ponto.S2, isFdsNeutro) }))] })), _jsx(TableCell, { children: renderStatusDia(linha.status_dia, isFdsNeutro) }), _jsx(TableCell, { children: renderJustificativa(linha.justificativa, isFdsNeutro) })] }), linha.data));
                                        }) })] })) })), ((_l = dados.assinatura_eletronica) === null || _l === void 0 ? void 0 : _l.exibir) && (_jsxs(Box, __assign({ sx: {
                                mx: 2.5,
                                mt: 2,
                                mb: 1,
                                p: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                backgroundColor: '#f0fdf4',
                                border: '1px solid #bbf7d0',
                                borderRadius: 2,
                            } }, { children: [_jsx(DrawIcon, { sx: { color: '#16a34a', fontSize: 28 } }), _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#166534', fontWeight: 500, fontSize: '0.82rem' } }, { children: dados.assinatura_eletronica.texto }))] })))] })) : (_jsxs(Box, __assign({ sx: {
                        p: 6,
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 3,
                        m: { xs: 2, md: 4 },
                        gap: 3,
                    } }, { children: [_jsx(Box, __assign({ sx: {
                                backgroundColor: '#f3f4f6',
                                p: 2.5,
                                borderRadius: '50%',
                                display: 'flex',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                            } }, { children: _jsx(FileIcon, { sx: { fontSize: 48, color: '#9ca3af' } }) })), _jsxs(Box, __assign({ sx: { textAlign: 'center' } }, { children: [_jsx(Typography, __assign({ variant: 'h6', sx: { fontWeight: 700, color: '#374151', mb: 1, letterSpacing: '-0.01em' } }, { children: "Folha n\u00E3o dispon\u00EDvel" })), _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#6b7280', maxWidth: 350, mx: 'auto', lineHeight: 1.5 } }, { children: "A folha ainda n\u00E3o est\u00E1 dispon\u00EDvel para visualiza\u00E7\u00E3o." }))] })), _jsx(Button, __assign({ id: 'btn-fechar-detalhamento', variant: 'outlined', onClick: onClose, sx: {
                                mt: 1,
                                fontWeight: 600,
                                color: '#4b5563',
                                borderColor: '#d1d5db',
                                borderRadius: 2,
                                px: 4,
                                py: 1,
                                textTransform: 'none',
                                backgroundColor: '#ffffff',
                                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                                '&:hover': { backgroundColor: '#f9fafb', borderColor: '#d1d5db' },
                            } }, { children: "Fechar Janela" }))] }))) })), dados && (_jsxs(DialogActions, __assign({ sx: {
                    px: 2.5,
                    py: 2,
                    borderTop: '1px solid #e5e7eb',
                    backgroundColor: getRodapeBg(),
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: 1.5,
                } }, { children: [((_m = dados.rodape) === null || _m === void 0 ? void 0 : _m.mensagem) && (_jsx(Typography, __assign({ variant: 'body2', sx: {
                            color: getRodapeMsgColor(),
                            fontWeight: 600,
                            fontSize: '0.82rem',
                            textAlign: 'center',
                        } }, { children: dados.rodape.mensagem }))), _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'flex-end', gap: 1 } }, { children: [((_o = dados.rodape) === null || _o === void 0 ? void 0 : _o.exportar_pdf_visivel) && (_jsx(Button, __assign({ id: 'btn-exportar-pdf', variant: 'contained', startIcon: _jsx(PdfIcon, {}), onClick: handleExportarPdf, sx: {
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    backgroundColor: '#166534',
                                    color: 'white',
                                    borderRadius: 2,
                                    px: 3,
                                    '&:hover': { backgroundColor: '#15803d' },
                                } }, { children: "EXPORTAR PDF DETALHADO" }))), _jsx(Button, __assign({ id: 'btn-fechar-detalhamento', variant: 'outlined', onClick: onClose, sx: {
                                    fontWeight: 700,
                                    color: '#4b5563',
                                    borderColor: '#d1d5db',
                                    borderRadius: 2,
                                    px: 3,
                                    backgroundColor: '#ffffff',
                                    '&:hover': { backgroundColor: '#f3f4f6', borderColor: '#d1d5db' },
                                } }, { children: "FECHAR JANELA" }))] }))] })))] })));
}
